import { XUIRadio, XUIRadioGroup } from '@xero/xui/react/radio';
import { FC, ReactNode, useState } from 'react';
import './index.css';

export interface IProgressiveDisclosureProps {
    trueLabel: string;
    falseLabel: string;
    initialState: boolean;
    isDisabled?: boolean;
    label: ReactNode;
    groupName: string;
    description?: string;
    qaHook?: string;
    onChange: (value: boolean) => void;
}

const ProgressiveDisclosure: FC<IProgressiveDisclosureProps> = ({
    trueLabel,
    falseLabel,
    initialState,
    label,
    isDisabled,
    groupName,
    description,
    onChange,
    qaHook,
    children,
}) => {
    const [state, setState] = useState(initialState);
    const onSelectionChange = (value: boolean) => {
        setState(value);
        onChange(value);
    };

    return (
        <div data-automationid={qaHook} data-testid={qaHook}>
            <div className='xui-padding-top-xlarge'>{description}</div>
            <div className='xui-padding-top-xlarge'>
                <XUIRadioGroup label={label} className='grid-horizontal-direction'>
                    <XUIRadio
                        name={groupName}
                        isChecked={state}
                        isDisabled={isDisabled}
                        onChange={() => onSelectionChange(true)}
                    >
                        {trueLabel}
                    </XUIRadio>
                    <XUIRadio
                        name={groupName}
                        isChecked={state === undefined ? undefined : !state}
                        isDisabled={isDisabled}
                        onChange={() => onSelectionChange(false)}
                    >
                        {falseLabel}
                    </XUIRadio>
                </XUIRadioGroup>
            </div>
            {state ? (
                <div className='xui-margin-top-large xui-padding-bottom-xlarge xui-padding-top-xsmall disclosure-container'>
                    {children}
                </div>
            ) : null}
        </div>
    );
};

export default ProgressiveDisclosure;
